import type { FC } from "react";
import { useCallback } from "react";
import { translate } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { SubsectionHeader } from "@similarweb/ui-components";

export const DigitalSuiteGenericBarHeader: FC<any> = ({ state, title, navBadgeType, badgeText }) => {
    const handleClick = useCallback((stateName) => {
        proNavigator.go(stateName);
    }, []);

    return (
        <SubsectionHeader
            id={state}
            text={translate(title)}
            onClick={handleClick}
            navBadgeType={navBadgeType}
            badgeText={badgeText}
        />
    );
};
